import {
  addMonths,
  compareAsc,
  differenceInCalendarMonths,
  endOfDay,
  format,
  lastDayOfMonth
} from 'date-fns'

import { TODAY } from '../const'

export const SUNDAY = 0
export const MONDAY = 1
export const TUESDAY = 2
export const WEDNESDAY = 3
export const THURSDAY = 4
export const FRIDAY = 5
export const SATURDAY = 6

export function formatDateShort(date: Date): string {
  return date.toLocaleString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })
}

export const getLastDayOfEveryMonthBetweenDates = (start: Date, end: Date) => {
  const lastDayOfStart = lastDayOfMonth(start)
  const lastDayOfEnd = lastDayOfMonth(end)

  const dates = [lastDayOfStart]
  const amountOfMonthsBetween = differenceInCalendarMonths(lastDayOfEnd, lastDayOfStart)
  for (let i = 0; i < amountOfMonthsBetween; i++) {
    const latestDate = dates[dates.length - 1]
    const monthAfterLatestDate = addMonths(latestDate, 1)
    const lastDayOfNextMonth = endOfDay(lastDayOfMonth(monthAfterLatestDate))
    dates.push(lastDayOfNextMonth)
  }
  return dates
}

export function formatToDatePartOnly(dateStr: string): string {
  return format(new Date(dateStr), 'yyyy-MM-dd')
}

export function formatToServerDate(date: Date): string {
  // Explicitly stripping time component and setting to all 0 as UTC
  return `${format(date, 'yyyy-MM-dd')}T00:00:00.000Z`
}

export function formatToServerDateFromStr(dateStr: string): string {
  return formatToServerDate(new Date(dateStr))
}

export function formatToServerDateAsQueryString(dateStr: string): string {
  return `${format(new Date(dateStr), 'yyyy-MM-dd')}`
}

export function formatToDateDisplay(date: string): string {
  return format(new Date(date), 'dd/MM/yyyy')
}

export const formatToDateTimeDisplay = (dateTime: string) =>
  dateTime ? format(new Date(dateTime), 'dd MMMM yyyy, HH:mm') : '-'

export const formatToValuationDateDisplay = (date: string) =>
  date ? format(new Date(date), 'dd MM yyyy') : '-'

// Compare just the date part (excludes time component)
// return false when date is today
export const isPastDate = (anyDate: string) => {
  const dateObj = new Date(anyDate)
  const result = compareAsc(
    new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()),
    new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate())
  )
  if (result < 0) return true
  return false
}
